import { render, staticRenderFns } from "./UiFileupload.vue?vue&type=template&id=b9e5a17e"
import script from "./UiFileupload.vue?vue&type=script&lang=js"
export * from "./UiFileupload.vue?vue&type=script&lang=js"
import style0 from "./UiFileupload.vue?vue&type=style&index=0&id=b9e5a17e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports